module.exports = __webpack_public_path__ + "static/media/textMessage_icon.3c45199c.svg";